/**
 * @generated SignedSource<<bbc36beb1b04c2ee2be38b4848b061da>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UnlockRequestStatus = "ERROR" | "EXECUTED" | "PENDING" | "TIMED_OUT" | "UNLOCKED" | "%future added value";
export type resultUnlockRequestQuery$variables = {
  unlockRequestId: string;
};
export type resultUnlockRequestQuery$data = {
  readonly unlockRequest: {
    readonly error: string | null | undefined;
    readonly id: string;
    readonly reservation: {
      readonly id: string;
      readonly space?: {
        readonly frame: string;
        readonly hub: {
          readonly id: string;
          readonly meta: {
            readonly id: string;
            readonly name: string;
            readonly street: string;
          } | null | undefined;
          readonly slug: string;
        };
        readonly id: string;
        readonly position: number;
      };
    };
    readonly status: UnlockRequestStatus;
    readonly unlockedAt: any | null | undefined;
  };
};
export type resultUnlockRequestQuery = {
  response: resultUnlockRequestQuery$data;
  variables: resultUnlockRequestQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "unlockRequestId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "unlockRequestId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unlockedAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "error",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "position",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "frame",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Hub",
          "kind": "LinkedField",
          "name": "hub",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "HubMeta",
              "kind": "LinkedField",
              "name": "meta",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "street",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RaffleReservation",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "resultUnlockRequestQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "UnlockRequest",
          "kind": "LinkedField",
          "name": "unlockRequest",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            (v5/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "reservation",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                (v6/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "resultUnlockRequestQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UnlockRequest",
        "kind": "LinkedField",
        "name": "unlockRequest",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "reservation",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9c594175b8ed345296d40b45f91dcf7b",
    "id": null,
    "metadata": {},
    "name": "resultUnlockRequestQuery",
    "operationKind": "query",
    "text": "query resultUnlockRequestQuery(\n  $unlockRequestId: UUID!\n) {\n  unlockRequest(id: $unlockRequestId) {\n    id\n    status\n    unlockedAt\n    error\n    reservation {\n      __typename\n      id\n      ... on RaffleReservation {\n        space {\n          id\n          position\n          frame\n          hub {\n            id\n            slug\n            meta {\n              id\n              name\n              street\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "22874e14375097d0f5ac9a9b3ce4237d";

export default node;
